import type { Lang } from '../types/funnel';

const en = {
  brandSub: 'Moving & Storage · Tampa',
  langSwitch: 'Español',
  langSwitchAria: 'Cambiar a español',
  callKyle: 'Call IMF Tampa Movers',
  aiLabel: 'AI-assisted phone support',
  humanHelp: 'Talk to a person',
  callShort: 'Call',
  homeTitle1: 'Moving in Tampa?',
  homeTitle2: 'Build your move in minutes.',
  homeSub: 'Choose your belongings and services. Review every charge. Book online.',
  homeArea: 'Tampa and nearby communities within our service area.',
  homeAreaDetail: 'Both addresses must be within 50 miles of our Tampa base — we check them during your plan.',
  card1: 'Studio / 1 Bedroom',
  card2: '2 Bedrooms',
  card3: '3 Bedrooms',
  card4: '4 Bedrooms',
  crewHint2: 'Usually 2 movers',
  crewHint23: '2 or 3 movers',
  crewHint3: 'Usually 3 movers',
  crewHint3r: '3 movers · reviewed with you',
  more5: '5+ bedrooms',
  fewItems: 'Only a few items',
  ctaCustomize: 'Book your move online',
  howTitle: 'How it works',
  how1: 'Tell us about your move',
  how1Body: 'Rooms, addresses, stairs or elevator, and what you’re moving.',
  how2: 'Review your estimate',
  how2Body: 'Crew, estimated hours and every charge itemized before you decide.',
  how3: 'Accept terms and reserve with $99',
  how3Body: 'The deposit is credited to your final bill.',
  how3Preview: 'Request your estimate',
  how3PreviewBody: 'Our team confirms availability, documents and your $99 deposit with you.',
  ratesTitle: 'Clear hourly rates',
  rate2: '2 movers + 1 truck',
  rate3: '3 movers + 1 truck',
  perHour: '/hour',
  ratesNote: '4-hour service minimum, plus 1 travel hour and a 20% operating surcharge. Packing and materials are extra.',
  helpQuick: 'Quick answers',
  stepSize: 'Home',
  stepAddresses: 'Addresses',
  stepAccess: 'Access',
  stepInventory: 'Inventory',
  stepPacking: 'Packing & truck',
  stepDate: 'Date',
  stepContact: 'Contact',
  stepEstimate: 'Estimate',
  stepReserve: 'Reserve',
  stepStatus: 'Status',
  back: 'Back',
  next: 'Continue',
  acceptContinue: 'Accept estimate & continue',
  summary: 'Your move',
  close: 'Close',
  saved: 'Progress saved on this device',
  editDetails: 'Edit',
  sizeTitle: 'What are you moving?',
  typeLabel: 'Property type',
  htApartment: 'Apartment',
  htHouse: 'House',
  htTownhome: 'Townhome',
  htOffice: 'Office / special move',
  bedTitle: 'How many bedrooms?',
  bedStudio: 'Studio',
  bedOne: '1 bedroom',
  bedMany: '{n} bedrooms',
  bed5: '5+ bedrooms',
  bedFew: 'Only a few items',
  adNote: 'We started with the size from your ad — change it anytime.',
  suggestTitle: 'Common items for this home',
  suggestBody: 'Tap to add what you actually have. Nothing is added unless you choose it.',
  addAll: 'Add all suggestions',
  added: 'Added',
  addrTitle: 'Where are you moving?',
  addrIntro: 'Pickup and destination. Keep the apartment or unit separate from the street address.',
  fromLabel: 'Pickup',
  toLabel: 'Destination',
  streetLabel: 'Street address',
  unitLabel: 'Apt / unit / building / community',
  zipLabel: 'ZIP code',
  addrManual: 'Typed addresses aren’t verified yet — our team checks them before any reservation.',
  zoneEligible: 'Both ZIP codes look like they’re in our Tampa service area. We confirm the exact addresses before reserving.',
  zoneReview: 'One location may be near the edge of our service area. Continue — our team will review the route with you.',
  zoneOutside: 'This route looks outside our local Tampa area. Continue and we’ll save your details so our team can review options — no local deposit is taken for it.',
  accessTitle: 'Access at both homes',
  accessIntro: 'Stairs, elevators and walking distance change the time and crew. “Ground floor” means street level.',
  originHome: 'Pickup',
  destHome: 'Destination',
  floorLabel: 'What level is it on?',
  flGround: 'Ground floor (street level)',
  flSecond: '2nd floor',
  flThird: '3rd floor',
  flFourth: '4th floor or higher',
  methodLabel: 'How do we get there?',
  mStairs: 'Stairs',
  mPassenger: 'Passenger elevator',
  mFreight: 'Freight / service elevator',
  flightsLabel: 'Flights of stairs',
  elevResLabel: 'Must the elevator be booked?',
  sharedElevLabel: 'Shared with residents during the move?',
  truckNearLabel: 'Can the truck park legally near the entrance?',
  gateLabel: 'Gate code or HOA restrictions?',
  coiLabel: 'Does the building require a certificate of insurance (COI)?',
  yes: 'Yes',
  no: 'No',
  unsure: 'Not sure',
  carryLabel: 'Walking distance from truck parking to the door',
  carryHelp: 'Count the whole walk once: truck → entrance → elevator → unit door. Don’t include floor height.',
  cb0_20: '0–20 ft',
  cb21_40: '21–40 ft',
  cb41_60: '41–60 ft',
  cb61_100: '61–100 ft',
  cbover_100: 'Over 100 ft',
  cbunsure: 'Not sure',
  car1: '≈ 1 car length',
  car2: '≈ 2 car lengths',
  car4: '≈ 4 car lengths',
  car6: '≈ 4–7 car lengths',
  car7: 'more than 7',
  carNone: 'measure later',
  carNote: 'A compact sedan is about 15 ft long. Approximate only.',
  feetLabel: 'Exact feet (optional)',
  accessNotesLabel: 'Notes for dispatch (parking, truck limits, house color)',
  invTitle: 'What are we moving?',
  invIntro: 'Choose items room by room. Suggestions are only ideas — you decide what’s included.',
  suggested: 'Suggested',
  addSuggestedRoom: 'Add suggestions for this room',
  invItems: '{n} items',
  decrease: 'Decrease',
  increase: 'Increase',
  addItemLabel: 'Add another item',
  addItemPlaceholder: 'e.g. treadmill, aquarium',
  addItemBtn: 'Add',
  remove: 'Remove',
  invUnsure: 'I’m not sure yet — please help me confirm the list',
  disassembly: 'Some furniture needs disassembly / reassembly',
  specialTitle: 'Heavy, fragile or special items',
  specialHelp: 'These get a quick review so we bring the right equipment.',
  invNotes: 'Notes about your items',
  errInventory: 'Add at least one item, or tell us you’re not sure yet',
  packTitle: 'Already packed, or want help?',
  packSelf: 'I’ve packed my belongings',
  packSelfBody: 'You pack the boxes. Your crew still wraps and protects furniture.',
  packPro: 'I want professional packing help',
  packProBody: 'Optional paid packing with proper cartons, dividers and labels.',
  protectTitle: 'Careful packing for the belongings you want to keep',
  protect1: 'Padded blankets fitted around furniture',
  protect2: 'Reinforced corners and edges',
  protect3: 'Proper carton sizes for each item',
  protect4: 'Dish dividers that keep plates upright',
  protect5: 'Floors and doorways protected',
  protect6: 'Orderly labels so unpacking is easy',
  protectNote: 'Professional techniques suited to a local move.',
  packProductsTitle: 'Choose packing help',
  pricedByTeam: 'Priced by our team',
  packTimeNote: 'Packing adds time on move day — we plan it into your crew’s schedule.',
  dateTitle: 'When would you like to move?',
  dateLabel: 'Preferred date',
  dateUnsure: 'I’m not sure of the date yet',
  arrivalLabel: 'Preferred arrival time',
  arr8: '8 AM',
  arrNoon: 'Noon',
  arr3: '3 PM',
  arrOther: 'Another time',
  arrOtherLabel: 'What time works for you?',
  arrivalNote: 'These are preferences. Our dispatch team confirms real availability.',
  anotherTimeCopy: 'Need another time? Tell us what you need and we’ll help coordinate it.',
  contactTitle: 'Where should we send your estimate?',
  firstName: 'First name',
  lastName: 'Last name',
  phone: 'Mobile number',
  email: 'Email',
  commLang: 'Preferred language',
  channelLabel: 'Best way to reach you',
  chCall: 'Phone call',
  chText: 'Text',
  chEmail: 'Email',
  consentQuote: 'I agree IMF Tampa Movers may use these details to prepare and follow up on my moving quote.',
  consentSms: 'I agree to receive text messages from InstaMovers Florida (IMF Tampa Movers) about this move: quote updates, scheduling, documents and booking status. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. Not required to get a quote. No marketing messages.',
  consentAi: 'You may call me about this move, including from IMF Tampa Movers’ AI-assisted phone line.',
  consentOptional: 'Optional',
  consentRequired: 'Required',
  errRequired: 'This field is required',
  errPhone: 'Enter a 10-digit US mobile number',
  errEmail: 'Enter a valid email address',
  errConsent: 'Please agree so we can prepare your quote',
  errZip: 'Enter a 5-digit ZIP code',
  errDate: 'Choose a date, or tell us you’re not sure yet',
  errArrival: 'Choose an arrival time',
  errPayer: 'Enter the payer’s name and email',
  estTitle: 'Your moving estimate',
  estSub: 'Hourly estimate — not a fixed price. Your final bill is based on actual time worked.',
  crewLabel: 'Crew',
  moversN: '{n} movers',
  recommended: 'Recommended',
  yourChoice: 'Your choice',
  crewPrefLabel: 'Crew size',
  crewRec: 'Recommended ({n})',
  crew2: '2 movers',
  crew3: '3 movers',
  crewPrefNote: 'Our team confirms {n} movers can handle this safely before your move.',
  serviceLabel: 'Estimated service time',
  hoursRange: '{a}–{b} hours',
  hoursN: '{n} h',
  minimumNote: '4-hour service minimum applies',
  rateLabel: '{n} movers + 1 truck',
  lineRate: 'Hourly rate',
  lineService: 'Service time (estimated)',
  lineTravel: 'Travel (base ↔ your move)',
  lineLabor: 'Labor + travel',
  lineSurcharge: 'Operating surcharge (20%)',
  surchargePending: 'Amount shown once its calculation is confirmed',
  linePacking: 'Packing & materials',
  lineDeposit: 'Deposit to reserve',
  depositCredit: 'Credited to your final bill — not an extra charge.',
  lineRemaining: 'Estimated remaining',
  remainingNote: 'Before the operating surcharge and any extras. Final bill is based on actual time.',
  rateByTeam: 'Set by our team for this crew size',
  reviewTitle: 'Our team will check a few details',
  rr_zone: 'Your route is near or outside our local service area',
  rr_special: 'Special items need the right equipment',
  rr_bigInventory: 'Your inventory is larger than typical for this home size',
  rr_large: 'Larger homes get a crew and truck review',
  rr_elevator: 'Elevator access needs a quick check',
  rr_stairsHigh: '4th floor or higher by stairs needs planning',
  rr_longCarry: 'A walk over 100 ft needs review',
  rr_crewPref: 'We’ll confirm your crew-size choice is safe for this move',
  cr_1: 'Two movers usually handle a studio or 1-bedroom well, including upper-floor stairs.',
  cr_2: 'Two movers fit most 2-bedroom moves on the ground or 2nd floor.',
  cr_2_third: 'For a 2-bedroom up to the 3rd floor by stairs, we recommend three movers for safe carrying and a faster day.',
  cr_3: 'We recommend three movers for a 3-bedroom so heavy pieces move safely and steadily.',
  cr_3_upper: 'Upper-floor stairs with a 3-bedroom go safer and faster with three movers.',
  cr_45: 'Larger homes start with three movers. We review whether more help makes sense.',
  cr_elevator: 'Elevator time depends on the building — we review access to plan the right crew.',
  cr_stairsHigh: 'Four or more flights of stairs need careful planning — our team confirms the crew.',
  acceptNote: 'Accepting saves this estimate version. If you change anything later, we’ll ask you to review it again.',
  reserveTitle: 'Review and reserve',
  reserveIntro: 'Here’s what applies to your booking before any payment.',
  staleTitle: 'Your estimate changed',
  staleBody: 'You edited your move after accepting the estimate. Please review the updated version.',
  staleBtn: 'Review updated estimate',
  versionLabel: 'Estimate version',
  docsTitle: 'Documents for this booking',
  docBooking: 'Booking acceptance & terms',
  docDeposit: 'Deposit card authorization',
  docThird: 'Third-party cardholder authorization',
  docFull: 'Full balance authorization',
  docBol: 'Bill of Lading',
  whoYou: 'You',
  whoCardholder: 'Cardholder',
  whoPayer: 'Payer',
  whenNow: 'Before reservation',
  whenLater: 'On move day',
  docStatusNot: 'Sent by our team for secure signing',
  payerTitle: 'Who is paying?',
  payerMe: 'I’m paying',
  payerOther: 'Someone else is paying',
  payerName: 'Payer’s full name',
  payerEmail: 'Payer’s email',
  payerPhone: 'Payer’s mobile (optional)',
  methodTitle: 'Payment method',
  payCard: 'Card',
  payZelle: 'Zelle',
  zelleNote: 'Our team shares the Zelle details. After you send it, a team member verifies it with the bank — it shows as “Zelle verification pending” until then.',
  cancelTitle: 'Changes and cancellation',
  cancelBody: 'You can cancel or change your date with at least 72 hours’ notice. The exact refund terms are in your booking agreement, which you’ll see before paying.',
  reserve99: 'Reserve with $99',
  prepay: 'Prepay my estimated move',
  notAvailable: 'Not available online yet',
  requestEstimate: 'Request your estimate',
  requestNote: 'We’ll review your plan and contact you to confirm availability, documents and your $99 deposit.',
  submitting: 'Sending…',
  submitError: 'Something went wrong sending your request. Your answers are saved — try again or call us.',
  retry: 'Try again',
  statusTitle: 'Your request',
  previewBanner: 'Preview mode: this request is saved on this device only and has not reached our team yet. Please call to finish it.',
  liveReceived: 'Request received — our team will contact you.',
  refLabel: 'Reference',
  rowEstimate: 'Estimate',
  rowDocuments: 'Documents',
  rowDeposit: 'Deposit',
  rowDispatch: 'Dispatch',
  stAccepted: 'Accepted by you',
  stDocsNot: 'Not signed — our team sends them',
  stDepNot: 'Not paid',
  stDepZelle: 'Not paid — Zelle verified by our team',
  stDispatch: 'Pending team review',
  nextTitle: 'What happens next',
  next1: 'Our team reviews your addresses, access and items.',
  next2: 'We confirm the date, crew and documents with you.',
  next3: 'Your move is confirmed only after documents, deposit and dispatch are complete.',
  newMove: 'Start another move',
  footerScope: 'Local moves in Tampa and nearby communities within our service area.',
  footerStaff: 'Staff console',
  footerLegal: 'IMF Tampa Movers is a service of InstaMovers Florida.',
  homeSubPreview: 'Choose your belongings and services. Review every charge. Request your estimate online.',
  ctaPreview: 'Build your move online',
  rr_stops: 'Extra stops add drive and handling time — our team plans the route with you.',
  rr_variantReview: 'One or more items (glass/stone tops or very large TVs) need specific handling review.',
  rr_truckSmall: 'The truck size you picked may be small for your list — our team will suggest an adjustment.',
  callFloating: 'Call IMF Tampa Movers',
};

export type StringKey = keyof typeof en;

const es: Record<StringKey, string> = {
  brandSub: 'Mudanzas y almacenaje · Tampa',
  langSwitch: 'English',
  langSwitchAria: 'Switch to English',
  callKyle: 'Llama a IMF Tampa Movers',
  aiLabel: 'Atención telefónica con asistencia de IA',
  humanHelp: 'Hablar con una persona',
  callShort: 'Llamar',
  homeTitle1: '¿Se muda en Tampa?',
  homeTitle2: 'Arma tu mudanza en minutos.',
  homeSub: 'Elige tus pertenencias y servicios. Revisa cada cargo. Reserva online.',
  homeArea: 'Tampa y comunidades cercanas dentro de nuestra área de servicio.',
  homeAreaDetail: 'Ambas direcciones deben estar a menos de 50 millas de nuestra base en Tampa — las revisamos durante su plan.',
  card1: 'Estudio / 1 recámara',
  card2: '2 recámaras',
  card3: '3 recámaras',
  card4: '4 recámaras',
  crewHint2: 'Normalmente 2 trabajadores',
  crewHint23: '2 o 3 trabajadores',
  crewHint3: 'Normalmente 3 trabajadores',
  crewHint3r: '3 trabajadores · lo revisamos con usted',
  more5: '5+ recámaras',
  fewItems: 'Solo unos cuantos artículos',
  ctaCustomize: 'Reserva tu mudanza online',
  howTitle: 'Cómo funciona',
  how1: 'Cuéntenos sobre su mudanza',
  how1Body: 'Habitaciones, direcciones, escaleras o elevador y lo que va a mudar.',
  how2: 'Revise su estimado',
  how2Body: 'Equipo, horas estimadas y cada cargo detallado antes de decidir.',
  how3: 'Acepte los términos y reserve con $99',
  how3Body: 'El depósito se acredita a su factura final.',
  how3Preview: 'Solicite su estimado',
  how3PreviewBody: 'Nuestro equipo confirma con usted la disponibilidad, los documentos y su depósito de $99.',
  ratesTitle: 'Tarifas por hora claras',
  rate2: '2 trabajadores + 1 camión',
  rate3: '3 trabajadores + 1 camión',
  perHour: '/hora',
  ratesNote: 'Mínimo de 4 horas de servicio, más 1 hora de traslado y un recargo operativo del 20%. Empaque y materiales aparte.',
  helpQuick: 'Respuestas rápidas',
  stepSize: 'Hogar',
  stepAddresses: 'Direcciones',
  stepAccess: 'Acceso',
  stepInventory: 'Inventario',
  stepPacking: 'Empaque y camión',
  stepDate: 'Fecha',
  stepContact: 'Contacto',
  stepEstimate: 'Estimado',
  stepReserve: 'Reservar',
  stepStatus: 'Estado',
  back: 'Atrás',
  next: 'Continuar',
  acceptContinue: 'Aceptar estimado y continuar',
  summary: 'Su mudanza',
  close: 'Cerrar',
  saved: 'Progreso guardado en este dispositivo',
  editDetails: 'Editar',
  sizeTitle: '¿Qué va a mudar?',
  typeLabel: 'Tipo de propiedad',
  htApartment: 'Apartamento',
  htHouse: 'Casa',
  htTownhome: 'Townhome',
  htOffice: 'Oficina / mudanza especial',
  bedTitle: '¿Cuántas recámaras?',
  bedStudio: 'Estudio',
  bedOne: '1 recámara',
  bedMany: '{n} recámaras',
  bed5: '5+ recámaras',
  bedFew: 'Solo unos cuantos artículos',
  adNote: 'Comenzamos con el tamaño de su anuncio — cámbielo cuando quiera.',
  suggestTitle: 'Artículos comunes para este hogar',
  suggestBody: 'Toque para agregar lo que realmente tiene. No se agrega nada a menos que usted lo elija.',
  addAll: 'Agregar todas las sugerencias',
  added: 'Agregado',
  addrTitle: '¿A dónde se muda?',
  addrIntro: 'Recogida y destino. Mantenga el apartamento o unidad separado de la dirección.',
  fromLabel: 'Recogida',
  toLabel: 'Destino',
  streetLabel: 'Dirección',
  unitLabel: 'Apto / unidad / edificio / comunidad',
  zipLabel: 'Código postal',
  addrManual: 'Las direcciones escritas aún no están verificadas — nuestro equipo las revisa antes de cualquier reserva.',
  zoneEligible: 'Ambos códigos postales parecen estar en nuestra área de Tampa. Confirmamos las direcciones exactas antes de reservar.',
  zoneReview: 'Una ubicación puede estar al borde de nuestra área. Continúe — nuestro equipo revisará la ruta con usted.',
  zoneOutside: 'Esta ruta parece estar fuera de nuestra área local de Tampa. Continúe y guardaremos sus datos para que el equipo revise opciones — no se cobra depósito local.',
  accessTitle: 'Acceso en ambos hogares',
  accessIntro: 'Escaleras, elevadores y distancia a pie cambian el tiempo y el equipo. “Planta baja” significa a nivel de la calle.',
  originHome: 'Recogida',
  destHome: 'Destino',
  floorLabel: '¿En qué nivel está?',
  flGround: 'Planta baja (nivel de la calle)',
  flSecond: '2.º piso (EE. UU.)',
  flThird: '3.er piso (EE. UU.)',
  flFourth: '4.º piso o más',
  methodLabel: '¿Cómo se llega?',
  mStairs: 'Escaleras',
  mPassenger: 'Elevador de pasajeros',
  mFreight: 'Elevador de carga / servicio',
  flightsLabel: 'Tramos de escaleras',
  elevResLabel: '¿Hay que reservar el elevador?',
  sharedElevLabel: '¿Se comparte con residentes durante la mudanza?',
  truckNearLabel: '¿El camión puede estacionarse legalmente cerca de la entrada?',
  gateLabel: '¿Código de acceso o restricciones de HOA?',
  coiLabel: '¿El edificio exige un certificado de seguro (COI)?',
  yes: 'Sí',
  no: 'No',
  unsure: 'No sé',
  carryLabel: 'Distancia a pie del estacionamiento del camión a la puerta',
  carryHelp: 'Cuente todo el recorrido una vez: camión → entrada → elevador → puerta. No incluya la altura de los pisos.',
  cb0_20: '0–20 pies',
  cb21_40: '21–40 pies',
  cb41_60: '41–60 pies',
  cb61_100: '61–100 pies',
  cbover_100: 'Más de 100 pies',
  cbunsure: 'No sé',
  car1: '≈ 1 largo de auto',
  car2: '≈ 2 largos de auto',
  car4: '≈ 4 largos de auto',
  car6: '≈ 4–7 largos de auto',
  car7: 'más de 7',
  carNone: 'medir después',
  carNote: 'Un sedán compacto mide unos 15 pies. Solo aproximado.',
  feetLabel: 'Pies exactos (opcional)',
  accessNotesLabel: 'Notas para despacho (estacionamiento, límites para camión, color de la casa)',
  invTitle: '¿Qué vamos a mudar?',
  invIntro: 'Elija artículos por habitación. Las sugerencias son solo ideas — usted decide qué se incluye.',
  suggested: 'Sugerido',
  addSuggestedRoom: 'Agregar sugerencias de esta habitación',
  invItems: '{n} artículos',
  decrease: 'Disminuir',
  increase: 'Aumentar',
  addItemLabel: 'Agregar otro artículo',
  addItemPlaceholder: 'ej. caminadora, acuario',
  addItemBtn: 'Agregar',
  remove: 'Quitar',
  invUnsure: 'Aún no estoy seguro — ayúdenme a confirmar la lista',
  disassembly: 'Algunos muebles necesitan desarmarse / armarse',
  specialTitle: 'Artículos pesados, frágiles o especiales',
  specialHelp: 'Estos reciben una revisión rápida para traer el equipo adecuado.',
  invNotes: 'Notas sobre sus artículos',
  errInventory: 'Agregue al menos un artículo, o indíquenos que aún no está seguro',
  packTitle: '¿Ya empacó, o quiere ayuda?',
  packSelf: 'Ya empaqué mis pertenencias',
  packSelfBody: 'Usted empaca las cajas. Su equipo igual envuelve y protege los muebles.',
  packPro: 'Quiero ayuda profesional de empaque',
  packProBody: 'Empaque opcional con costo, con cajas adecuadas, divisores y etiquetas.',
  protectTitle: 'Empaque cuidadoso para las pertenencias que quiere conservar',
  protect1: 'Mantas acolchadas ajustadas a los muebles',
  protect2: 'Esquinas y bordes reforzados',
  protect3: 'Cajas del tamaño adecuado para cada artículo',
  protect4: 'Divisores que mantienen los platos en vertical',
  protect5: 'Pisos y puertas protegidos',
  protect6: 'Etiquetas ordenadas para desempacar fácil',
  protectNote: 'Técnicas profesionales adecuadas para una mudanza local.',
  packProductsTitle: 'Elija la ayuda de empaque',
  pricedByTeam: 'Precio fijado por nuestro equipo',
  packTimeNote: 'El empaque agrega tiempo el día de la mudanza — lo incluimos en el horario del equipo.',
  dateTitle: '¿Cuándo le gustaría mudarse?',
  dateLabel: 'Fecha preferida',
  dateUnsure: 'Aún no estoy seguro de la fecha',
  arrivalLabel: 'Hora de llegada preferida',
  arr8: '8 AM',
  arrNoon: 'Mediodía',
  arr3: '3 PM',
  arrOther: 'Otra hora',
  arrOtherLabel: '¿Qué hora le funciona?',
  arrivalNote: 'Son preferencias. Nuestro equipo de despacho confirma la disponibilidad real.',
  anotherTimeCopy: '¿Necesita otra hora? Díganos qué necesita y le ayudamos a coordinarlo.',
  contactTitle: '¿A dónde enviamos su estimado?',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Celular',
  email: 'Correo electrónico',
  commLang: 'Idioma preferido',
  channelLabel: 'Mejor forma de contactarle',
  chCall: 'Llamada',
  chText: 'Mensaje de texto',
  chEmail: 'Correo',
  consentQuote: 'Acepto que IMF Tampa Movers use estos datos para preparar y dar seguimiento a mi cotización.',
  consentSms: 'Acepto recibir mensajes de texto de InstaMovers Florida (IMF Tampa Movers) sobre esta mudanza: cotización, programación, documentos y estado de la reserva. La frecuencia varía. Pueden aplicar tarifas de mensajes y datos. Responda STOP para cancelar o HELP para ayuda. No es necesario para cotizar. Sin mensajes de marketing.',
  consentAi: 'Pueden llamarme sobre esta mudanza, incluso desde la línea con asistencia de IA de IMF Tampa Movers.',
  consentOptional: 'Opcional',
  consentRequired: 'Obligatorio',
  errRequired: 'Este campo es obligatorio',
  errPhone: 'Ingrese un celular de EE. UU. de 10 dígitos',
  errEmail: 'Ingrese un correo válido',
  errConsent: 'Acepte para que podamos preparar su cotización',
  errZip: 'Ingrese un código postal de 5 dígitos',
  errDate: 'Elija una fecha, o indíquenos que aún no está seguro',
  errArrival: 'Elija una hora de llegada',
  errPayer: 'Ingrese el nombre y correo de quien paga',
  estTitle: 'Su estimado de mudanza',
  estSub: 'Estimado por hora — no es un precio fijo. Su factura final se basa en el tiempo real trabajado.',
  crewLabel: 'Equipo',
  moversN: '{n} trabajadores',
  recommended: 'Recomendado',
  yourChoice: 'Su elección',
  crewPrefLabel: 'Tamaño del equipo',
  crewRec: 'Recomendado ({n})',
  crew2: '2 trabajadores',
  crew3: '3 trabajadores',
  crewPrefNote: 'Nuestro equipo confirma que {n} trabajadores pueden hacerlo con seguridad antes de la mudanza.',
  serviceLabel: 'Tiempo de servicio estimado',
  hoursRange: '{a}–{b} horas',
  hoursN: '{n} h',
  minimumNote: 'Aplica un mínimo de 4 horas de servicio',
  rateLabel: '{n} trabajadores + 1 camión',
  lineRate: 'Tarifa por hora',
  lineService: 'Tiempo de servicio (estimado)',
  lineTravel: 'Traslado (base ↔ su mudanza)',
  lineLabor: 'Mano de obra + traslado',
  lineSurcharge: 'Recargo operativo (20%)',
  surchargePending: 'El monto se muestra cuando su cálculo se confirme',
  linePacking: 'Empaque y materiales',
  lineDeposit: 'Depósito para reservar',
  depositCredit: 'Se acredita a su factura final — no es un cargo adicional.',
  lineRemaining: 'Restante estimado',
  remainingNote: 'Antes del recargo operativo y extras. La factura final se basa en el tiempo real.',
  rateByTeam: 'Fijada por nuestro equipo para este tamaño de equipo',
  reviewTitle: 'Nuestro equipo revisará algunos detalles',
  rr_zone: 'Su ruta está cerca o fuera de nuestra área local',
  rr_special: 'Los artículos especiales requieren el equipo adecuado',
  rr_bigInventory: 'Su inventario es mayor de lo típico para este tamaño de hogar',
  rr_large: 'Los hogares grandes reciben revisión de equipo y camión',
  rr_elevator: 'El acceso por elevador requiere una revisión rápida',
  rr_stairsHigh: 'Un 4.º piso o más por escaleras requiere planeación',
  rr_longCarry: 'Una caminata de más de 100 pies requiere revisión',
  rr_crewPref: 'Confirmaremos que su elección de equipo es segura para esta mudanza',
  cr_1: 'Dos trabajadores normalmente manejan bien un estudio o 1 recámara, incluso con escaleras.',
  cr_2: 'Dos trabajadores son adecuados para la mayoría de mudanzas de 2 recámaras en planta baja o 2.º piso.',
  cr_2_third: 'Para 2 recámaras hasta un 3.er piso por escaleras, recomendamos tres trabajadores para cargar con seguridad y avanzar más rápido.',
  cr_3: 'Recomendamos tres trabajadores para 3 recámaras para mover piezas pesadas con seguridad y a buen ritmo.',
  cr_3_upper: 'Con escaleras en pisos altos, 3 recámaras van más seguras y rápidas con tres trabajadores.',
  cr_45: 'Los hogares grandes empiezan con tres trabajadores. Revisamos si conviene más ayuda.',
  cr_elevator: 'El tiempo de elevador depende del edificio — revisamos el acceso para planear el equipo correcto.',
  cr_stairsHigh: 'Cuatro o más tramos de escaleras requieren planeación — nuestro equipo confirma el personal.',
  acceptNote: 'Al aceptar se guarda esta versión del estimado. Si cambia algo después, le pediremos revisarlo de nuevo.',
  reserveTitle: 'Revise y reserve',
  reserveIntro: 'Esto es lo que aplica a su reserva antes de cualquier pago.',
  staleTitle: 'Su estimado cambió',
  staleBody: 'Editó su mudanza después de aceptar el estimado. Revise la versión actualizada.',
  staleBtn: 'Revisar estimado actualizado',
  versionLabel: 'Versión del estimado',
  docsTitle: 'Documentos para esta reserva',
  docBooking: 'Aceptación de reserva y términos',
  docDeposit: 'Autorización de tarjeta para el depósito',
  docThird: 'Autorización del titular de tarjeta (tercero)',
  docFull: 'Autorización del saldo total',
  docBol: 'Conocimiento de embarque (Bill of Lading)',
  whoYou: 'Usted',
  whoCardholder: 'Titular de la tarjeta',
  whoPayer: 'Quien paga',
  whenNow: 'Antes de reservar',
  whenLater: 'El día de la mudanza',
  docStatusNot: 'Nuestro equipo los envía para firma segura',
  payerTitle: '¿Quién paga?',
  payerMe: 'Yo pago',
  payerOther: 'Otra persona paga',
  payerName: 'Nombre completo de quien paga',
  payerEmail: 'Correo de quien paga',
  payerPhone: 'Celular de quien paga (opcional)',
  methodTitle: 'Método de pago',
  payCard: 'Tarjeta',
  payZelle: 'Zelle',
  zelleNote: 'Nuestro equipo comparte los datos de Zelle. Después de enviarlo, una persona del equipo lo verifica con el banco — aparece como “Verificación de Zelle pendiente” hasta entonces.',
  cancelTitle: 'Cambios y cancelación',
  cancelBody: 'Puede cancelar o cambiar su fecha con al menos 72 horas de aviso. Los términos exactos de reembolso están en su contrato de reserva, que verá antes de pagar.',
  reserve99: 'Reservar con $99',
  prepay: 'Prepagar mi mudanza estimada',
  notAvailable: 'Aún no disponible en línea',
  requestEstimate: 'Solicitar mi estimado',
  requestNote: 'Revisaremos su plan y le contactaremos para confirmar disponibilidad, documentos y su depósito de $99.',
  submitting: 'Enviando…',
  submitError: 'Algo falló al enviar su solicitud. Sus respuestas están guardadas — intente de nuevo o llámenos.',
  retry: 'Intentar de nuevo',
  statusTitle: 'Su solicitud',
  previewBanner: 'Modo de vista previa: esta solicitud está guardada solo en este dispositivo y aún no ha llegado a nuestro equipo. Llame para completarla.',
  liveReceived: 'Solicitud recibida — nuestro equipo le contactará.',
  refLabel: 'Referencia',
  rowEstimate: 'Estimado',
  rowDocuments: 'Documentos',
  rowDeposit: 'Depósito',
  rowDispatch: 'Despacho',
  stAccepted: 'Aceptado por usted',
  stDocsNot: 'Sin firmar — nuestro equipo los envía',
  stDepNot: 'No pagado',
  stDepZelle: 'No pagado — Zelle verificado por nuestro equipo',
  stDispatch: 'Pendiente de revisión',
  nextTitle: 'Qué sigue',
  next1: 'Nuestro equipo revisa sus direcciones, acceso y artículos.',
  next2: 'Confirmamos con usted la fecha, el equipo y los documentos.',
  next3: 'Su mudanza se confirma solo cuando documentos, depósito y despacho estén completos.',
  newMove: 'Iniciar otra mudanza',
  footerScope: 'Mudanzas locales en Tampa y comunidades cercanas dentro de nuestra área de servicio.',
  footerStaff: 'Consola del equipo',
  footerLegal: 'IMF Tampa Movers es un servicio de InstaMovers Florida.',
  homeSubPreview: 'Elige tus pertenencias y servicios. Revisa cada cargo. Solicita tu estimado online.',
  ctaPreview: 'Arma tu mudanza online',
  rr_stops: 'Las paradas adicionales agregan tiempo de manejo y carga; nuestro equipo planifica la ruta con usted.',
  rr_variantReview: 'Uno o más artículos (cubiertas de vidrio/piedra o televisores muy grandes) requieren revisión de manejo.',
  rr_truckSmall: 'El camión que eligió podría quedar pequeño para su lista; nuestro equipo le sugerirá un ajuste.',
  callFloating: 'Llama a IMF Tampa Movers',
};

export const strings: Record<Lang, Record<StringKey, string>> = { en, es };

export function translate(lang: Lang, key: StringKey, vars?: Record<string, string | number>): string {
  let s = strings[lang][key] ?? strings.en[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, String(v));
  return s;
}

export function isStringKey(k: string): k is StringKey {
  return k in en;
}
